import { render, staticRenderFns } from "./CategorySubMenu.vue?vue&type=template&id=8097df00&scoped=true&"
import script from "./CategorySubMenu.vue?vue&type=script&lang=js&"
export * from "./CategorySubMenu.vue?vue&type=script&lang=js&"
import style0 from "./CategorySubMenu.vue?vue&type=style&index=0&id=8097df00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8097df00",
  null
  
)

export default component.exports